import { MaterialService } from './material.service';
import { ExerciceSpecificContentList } from './../model/exerciceSpecificContentList.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class ExerciceSpecificContentService extends KiwixiService {

    apiExerciceSpecificContent = environment.server + 'exercices_specific_contents/';

    constructor(
        private _http: HttpClient,
        private _router: Router,
        kiwixiGlobals: KiwixiGlobals,
        private materialService: MaterialService,) {
        super(_http, _router, kiwixiGlobals, materialService);
    }

    getExercicesSpecificContent(params: HttpParams): Observable<ExerciceSpecificContentList> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<ExerciceSpecificContentList>(this.apiExerciceSpecificContent, {
            headers: header,
            params: params
        })
            .pipe(
                map(_specificContent => _specificContent),
                catchError(this.handleErrorObservable<ExerciceSpecificContentList>(`getObservableExercicespecific Content List`))
            );
    }

}
